import {React, useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from '../../components/Common/Breadcrumb';
import { blogimg2, imguser } from '../../components/imagepath';
import { BASE_URL_IMAGE } from "../../config/api";

import { jwtDecode } from "jwt-decode";
import { fetchUserById } from "../../services/userService";



export const UserProfile = () => {
  // Static profile data
  const profileData = {
    user_id: "USR-001",
    user_name: "Admin User",
    user_email: "admin@example.com",
    user_contact: "1234567890",
    user_department: "Computer Science & Engineering",
    user_status: 1,
    user_role: 1,
    user_isFaculty: 0,
    user_profile_img: "",
    user_designation: "System Administrator",
    user_qualification: "M.Tech in Computer Science",
    user_specialization: "Cloud Computing",
    user_teaching_exp: "5 years",
    user_industrial_exp: "3 years",
    user_international_pub: "2 papers",
    user_domestic_pub: "3 papers",
    user_facebook: "https://facebook.com/admin",
    user_linkedin: "https://linkedin.com/in/admin"
  };

  // Determine role label and badge class
  let roleLabel = "N/A";
  let badgeClass = "bg-secondary";

  if (profileData.user_role == 1) {
    roleLabel = "Admin";
    badgeClass = "bg-dark";
  } else if (profileData.user_role == 2) {
    roleLabel = "Department Co-Ordinator";
    badgeClass = "bg-info";
  } else if (profileData.user_role == null && profileData.user_isFaculty == 1) {
    roleLabel = "Faculty";
    badgeClass = "bg-primary";
  }

  const breadcrumbItems = [
    { label: "Profile" },
    { label: profileData.user_name },
  ];

  const [userData,setUserData] = useState();
    useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setUserData(user);
        } catch (error) {
          console.error("Error decoding token or fetching user:", error);
        }
      }
    };
  
    fetchAndSetUser();
  }, []);

  return (
    <div>
      <Helmet><title>{profileData.user_name} | CRM Jnec</title></Helmet>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-6"><Breadcrumb items={breadcrumbItems} /></div>
              <div className="col-sm-5 col-6 text-end m-b-30">
                <Link to="/edit-profile" className="btn btn-primary btn-rounded">
                  Edit Profile
                </Link>


                <Link to="/forgot-password" className=" mx-3 btn btn-secondary btn-rounded">
                  Change Password
                </Link>
              </div>
            </div>
          </div>
          
          <div className="card-box profile-header">
            <div className="row">
              <div className="col-md-12">
                <div className="profile-view">
                  <div className="profile-img-wrap">
                    <div className="profile-img">
                       {userData?.user_profile_img ? (
                          <img src={`${BASE_URL_IMAGE}/uploads/userProfiles/${userData.user_profile_img}`} alt="Admin" />
                        ) : (
                          <img src={imguser} alt="Default" /> // fallback image
                        )}
                    </div>
                  </div>
                  <div className="profile-basic">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="profile-info-left mb-5">
                          <h3 className="user-name m-t-0 mb-0">{userData?.user_name || "Loading..."}</h3>
                          <small className="text-muted">
                            <span className={`badge ${badgeClass}`}>{roleLabel}</span>
                          </small>
                          {/* <div className="staff-id">User ID : {profileData.user_id}</div> */}
                          <div className="staff-id">{Date(userData?.created_at) || "Loading..."}</div>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <ul className="personal-info">
                          <li>
                            <span className="title">Phone:</span>
                            <span className="text">{userData?.user_contact || "Loading..."}</span>
                          </li>
                          <li>
                            <span className="title">Email:</span>
                            <span className="text">{userData?.user_email || "Loading..."}</span>
                          </li>
                          <li>
                            <span className="title">Department:</span>
                            <span className="text">{userData?.user_department || "Loading..."}</span>
                          </li>
                          <li>
                            <span className="title">Status:</span>
                            <span className="text">
                              {!userData ? (
                                <span className="text-muted">Loading...</span>
                              ) : (
                                <span className={`badge ${userData.user_status == 1 ? "bg-success" : "bg-secondary"}`}>
                                  {userData.user_status == 1 ? "Active" : "Inactive"}
                                </span>
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="profile-tabs">
            <div className="tab-content">
              <div className="tab-pane show active" id="about-cont">
                <div className="row">
                  {/* First Column */}
                  <div className="col-md-6">
                    <div className="card-box">
                      <h3 className="card-title">Professional Information</h3>
                      <div className="experience-box">
                        <ul className="experience-list">
                          <li>
                            <div className="experience-content">
                              <div className="timeline-content">
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Designation</strong></div>
                                  <div className="col-md-8">{userData?.user_designation || "Loading..."}</div>
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Qualification</strong></div>
                                  <div className="col-md-8">{userData?.user_qualification || "Loading..."}</div>
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Specialization</strong></div>
                                  <div className="col-md-8">{userData?.user_specialization || "Loading..."}</div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card-box">
                      <h3 className="card-title">Publications</h3>
                      <div className="experience-box">
                        <ul className="experience-list">
                          <li>
                            <div className="experience-content">
                              <div className="timeline-content">
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>International Publications</strong></div>
                                  <div className="col-md-8">{userData?.user_international_publication || "Loading..."}</div>
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Domestic Publications</strong></div>
                                  <div className="col-md-8">{userData?.user_domestic_publication || "Loading..."}</div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Second Column */}
                  <div className="col-md-6">
                    <div className="card-box">
                      <h3 className="card-title">Experience</h3>
                      <div className="experience-box">
                        <ul className="experience-list">
                          <li>
                            <div className="experience-content">
                              <div className="timeline-content">
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Teaching Experience</strong></div>
                                  <div className="col-md-8">{userData?.user_teaching_experience || "Loading..."}</div>
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Industrial Experience</strong></div>
                                  <div className="col-md-8">{userData?.user_industrial_experience || "Loading..."}</div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card-box">
                      <h3 className="card-title">Social Media</h3>
                      <div className="experience-box">
                        <ul className="experience-list">
                          <li>
                            <div className="experience-content">
                              <div className="timeline-content">
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>Facebook Profile</strong></div>
                                  <div className="col-md-8">
                                    <a href={userData?.user_facebook_link || "Loading..."} target="_blank" rel="noopener noreferrer">View</a>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-4"><strong>LinkedIn Profile</strong></div>
                                  <div className="col-md-8">
                                    <a href={userData?.user_linkedin_link || "Loading..."} target="_blank" rel="noopener noreferrer">View</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;